import { HEAD_COACH } from "@/data/site";
import { Eyebrow, FadeIn } from "@/components/blocks";

export default function Coach() {
  return (
    <section data-testid="coach-section" className="bg-ink px-6 py-28 text-bone sm:px-10 sm:py-36 lg:px-16">
      <div className="mx-auto grid max-w-[1440px] gap-16 lg:grid-cols-[0.85fr_1.15fr] lg:gap-24">
        <FadeIn>
          <div className="relative flex aspect-[3/4] items-center justify-center overflow-hidden border border-bone/15 bg-coal">
            {/* PLACEHOLDER — replace with Doneev Lama's professional photograph (HEAD_COACH.photo in src/data/site.js) */}
            <p className="font-display text-[9rem] font-black uppercase leading-none tracking-tight text-outline">
              DL
            </p>
            <p className="absolute bottom-6 left-6 font-mono text-[10px] uppercase tracking-[0.25em] text-ash">
              Doneev Lama — photograph forthcoming
            </p>
          </div>
        </FadeIn>

        <div>
          <FadeIn>
            <Eyebrow>The Coaching Standard</Eyebrow>
          </FadeIn>
          <FadeIn delay={0.1}>
            <h2 className="mt-8 font-display text-4xl font-black uppercase leading-[0.95] tracking-tight sm:text-5xl lg:text-6xl">
              Coaching led by experience. <span className="text-ash">Delivered through a system.</span>
            </h2>
          </FadeIn>
          <FadeIn delay={0.2}>
            <p className="mt-8 max-w-xl text-base leading-relaxed text-ash sm:text-lg">{HEAD_COACH.bio}</p>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-ash sm:text-lg">
              As StrengthLeap grows, trained coaches deliver programs under the same methodology — one standard,
              anywhere.
            </p>
          </FadeIn>

          <FadeIn delay={0.25}>
            <p className="mt-12 font-mono text-[10px] uppercase tracking-[0.3em] text-ash">Expertise across</p>
            <ul className="mt-5 flex flex-wrap gap-2.5">
              {HEAD_COACH.expertise.map((e) => (
                <li
                  key={e}
                  className="border border-bone/20 px-4 py-2 font-mono text-[11px] uppercase tracking-[0.18em] text-bone/85 transition-colors duration-300 hover:border-lime hover:text-lime"
                >
                  {e}
                </li>
              ))}
            </ul>
          </FadeIn>

          <FadeIn delay={0.3}>
            <div className="mt-12 border-t border-bone/15 pt-8">
              {/* PLACEHOLDER — replace name & qualifications with verified details before launch */}
              <p className="font-display text-xl font-black uppercase tracking-tight">
                {HEAD_COACH.name} <span className="ml-3 font-mono text-[10px] font-normal uppercase tracking-[0.25em] text-lime">{HEAD_COACH.role}</span>
              </p>
              <ul className="mt-4 space-y-2">
                {HEAD_COACH.qualifications.map((q) => (
                  <li key={q} className="flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.18em] text-ash">
                    <span className="h-px w-5 bg-lime" />
                    {q}
                  </li>
                ))}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>
  );
}
